import { getServerData } from 'js/src/libs/server-data';

export enum ServiceLevel {
    LOW,
    HIGH,
}

export function getServiceLevel(): ServiceLevel {
    const user = getServerData()?.USER;
    if (!user) {
        return ServiceLevel.LOW;
    }
    if (user.service_flags === null) {
        return ServiceLevel.LOW;
    }
    if (user.service_flags > 0) {
        return ServiceLevel.HIGH;
    }
    if (user.plan_price > 0) {
        return ServiceLevel.HIGH;
    }
    return ServiceLevel.LOW;
}

export function hasFeatureEnabled(featureFlagName: string): boolean {
    const featureFlags = getServerData()?.USER?.feature_flags;
    if (!featureFlags) {
        return false;
    }
    return featureFlags.includes(featureFlagName);
}

export function getPlanDisplayName(): string | undefined {
    return getServerData()?.USER?.plan_display_name;
}
